module.exports = __webpack_public_path__ + "static/media/default-avatar.5097b024.png";